/* oxlint-disable */
// @ts-nocheck
// The blank line below keeps these directives detached from the first import: oxfmt treats leading
// comments as belonging to the import they precede and moves them when sorting, which would hoist an
// import above @ts-nocheck and silently re-enable type checking for this file.

import { ReactNode, useEffect, useRef } from 'react'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'

const PYLON_APP_ID = '62e1bc80-65e7-4138-a839-11dee83bc15b'
let pylonScriptLoaded = false
const loadPylon = () => {
  if (pylonScriptLoaded) return
  pylonScriptLoaded = true
  var e = window
  var t = document
  var n = function () {
    n.e(arguments)
  }
  n.q = []
  n.e = function (e) {
    n.q.push(e)
  }
  e.Pylon = n
  e.pylon = {}
  var r = function () {
    var e = t.createElement('script')
    e.setAttribute('type', 'text/javascript')
    e.setAttribute('async', 'true')
    e.setAttribute('src', `https://widget.usepylon.com/widget/${PYLON_APP_ID}`)
    var n = t.getElementsByTagName('script')[0]
    n.parentNode.insertBefore(e, n)
  }
  if (t.readyState === 'complete') {
    r()
  } else if (e.addEventListener) {
    e.addEventListener('load', r, false)
  }
}

export const PylonProvider = ({ children }: { children: ReactNode }) => {
  const { user, org, isFullyAuthenticated } = useAuthenticatedUser()
  const lastConfiguredOrgId = useRef<string | null>(null)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      loadPylon()
      if (isFullyAuthenticated && user.hmac?.pylonUserHash && org.organisationId !== lastConfiguredOrgId.current) {
        lastConfiguredOrgId.current = org.organisationId
        window.pylon = {
          chat_settings: {
            app_id: PYLON_APP_ID,
            email: user.email,
            name: `${user.firstName} ${user.lastName}`,
            email_hash: user.hmac.pylonUserHash,
          },
        }
        window.Pylon('setNewIssueCustomFields', {
          user_id: user.id,
          user_email: user.email,
          organisation_name: org.name,
          organisation_id: org.organisationId,
        })
      }
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.pylon = {}
      }
      lastConfiguredOrgId.current = null
    }
  }, [isFullyAuthenticated, org.organisationId])

  return children
}
